import { Component, OnInit, AfterViewChecked, HostListener } from '@angular/core';

import { BasePrintEmailComponent } from './../shared/base-print-email.component';

@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.less' , './../shared/print-email.component.less']
})

export class PrintComponent extends BasePrintEmailComponent implements OnInit, AfterViewChecked {

    ngOnInit() {
      this.currentStep = 1;
      this.errors = [];
    }

    /**
     * resize the print confirm list table after view being checked
     */
    ngAfterViewChecked() {
      this.resizeConfirmTableHeight();
    }

    /**
     * resize the print confirm list table upone the window resize event
     * @param
     */
    @HostListener('window:resize', ['$event'])
    onResize($event) {
      this.resizeConfirmTableHeight();
    }

    printConfirm(): void {
      this.generatePdf()
        .subscribe(pdfUri => {
           this.currentStep = 2;
          });
    }

    donePrinting(): void {
      this.currentStep = 3;
    }

    /**
     * resize the confirm list table height, so that confirm button in the modal 
     * does not extend outside the window/viewport
     */
    resizeConfirmTableHeight() {
      if (this.currentStep === 1) {
        const  TOP_HEIGHT = 195;    // px;  -- height above the  confirm table
        const  BOTTOM_HEIGHT = 190; // px;  -- height under the confirm table (though not fixed for different window size)
        const  TABLE_HEIGHT_WITH_ONE_ROW = 58; // px; -- table height with one row

        // window and table height
        let windowHeight: number = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let tableWrapperDiv = document.getElementById('civil-print-table-wrapper-div') as HTMLElement; // print confirm list table
        let tableScrollHeight = tableWrapperDiv.scrollHeight;

        // modal size
        let modalSizeCalculated = tableScrollHeight + TOP_HEIGHT + BOTTOM_HEIGHT;

        // resize the confirm list table and keep at least one row in modal
        if (tableScrollHeight > TABLE_HEIGHT_WITH_ONE_ROW && modalSizeCalculated > windowHeight  ) {
             let heightDiff  =  modalSizeCalculated - windowHeight;
             let tableExpectedHeight =  tableScrollHeight - heightDiff;
             if (tableExpectedHeight >= TABLE_HEIGHT_WITH_ONE_ROW) { 
                tableWrapperDiv.style.height = tableExpectedHeight + 'px';
                tableWrapperDiv.style.overflowY = 'auto';
             } else {
                tableWrapperDiv.style.height = TABLE_HEIGHT_WITH_ONE_ROW + 'px';
                tableWrapperDiv.style.overflowY = 'auto';
             }
         } else {
            tableWrapperDiv.style.height = tableScrollHeight + 'px';
         }
      }
    }
}


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/print/print.component.ts